// jQuery wrapper
(function ($) {

	/**
	 ** Document ready
	 **/
	$(document).ready(function () {

		$('body').addClass('active');

		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function (event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - headerHeight;
			// var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
				scrollTop: scrollPosition
			}, 1000);
		});


		// Hamburger 
		$('.hamburger').click(function () {
			// var target = $(this).data('target');

			$(this).toggleClass('is-active');
			$('body').toggleClass('mobile-menu-open');

			// Close mobile menus
			$('#mobile-menu .hasSub > a').removeClass('current');
			$('#mobile-menu .sub-menu').removeClass('open');
		});

		// Mobile Menu
		$('#mobile-menu .hasSub > a').click(function (event) {
			event.preventDefault();
			var target = $(this).attr('href');

			if (!$(this).hasClass('current')) {
				$('#mobile-menu .hasSub > a').addClass('current');
				$(target).addClass('open');
			}
		});
		$('#mobile-menu .sub-menu .back').click(function () {
			$('#mobile-menu .hasSub > a').removeClass('current');
			$('#mobile-menu .sub-menu').removeClass('open');
		});


		// Desktop Main Menu - Treatment Submenu
		$('#main-menu .hasSub > a').click(function (event) {
			event.preventDefault();
			var target = $(this).attr('href');

			if ($(this).hasClass('current')) {
				$('body').removeClass('sub-menu-open');
				$('#main-menu .hasSub > a').removeClass('current');
				$('nav.sub-menu').removeClass('open');

			} else {
				$('body').addClass('sub-menu-open');

				$('#main-menu .hasSub > a').removeClass('current');
				$(this).addClass('current');

				$('nav.sub-menu').removeClass('open');
				$(target).addClass('open');
			}
		});


		// Login / Profile button
		var growbed_url = $('#site-header').data('growbed-api');
		$.ajax(growbed_url + '/api/search', {
			data: { origin: 'customer', paginate: 1, onlyIds: 1 },
			method: 'post',
			xhrFields: { withCredentials: true }
		}).then(response => {
			if (response.data && response.data.length) {
				$('#site-header .login-button').each(function () {
					$(this).find('.login-button-text').html('Profile');
					this.href = growbed_url + '/customer/profile';
					this.title = 'Go to your Profile';
				});

				$('#mobile-menu .login-button').each(function () {
					$(this).find('.login-button-text').html('Profile');
					this.href = growbed_url + '/customer/profile';
					this.title = 'Go to your Profile';
				});
			}
		});


		// Full Range of Courses
		if ($('.course-buttons').length > 0) {
			$('.course-buttons button').click(function () {
				var target = $(this).data('target'),
					parent = $(this).data('parent');

				// console.log(parent + ' ' + target);

				$(parent + ' .course-buttons button').removeClass('current');
				$(this).addClass('current');

				$(parent + ' .course-list').removeClass('active');
				$(target).addClass('active');

				$('.courses-carousel').slick('refresh');
			});
		}


		// Model form
		if ($('.page-model .form-wrap').length > 0) {
			modelFormLayout();

			// Condition checkbox list
			/*
			$('a.condition-toggle').click(function (event) {
				event.preventDefault;

				$('.conditions-list').toggleClass('show');

				modelFormLayout();
			});
			*/

		}


		// Accordion list (FAQs, Videos)
		if ($('.accordion-list').length > 0) {
			$('.accordion-list .answer').hide();
			// $('.accordion-list .answer:not(.active)').hide();

			$('.accordion-list .accordion-toggle').click(function () {
				var targetParent = $(this).data('parent');
				var target = $(this).data('target');

				// console.log(targetParent);

				if ($(target).hasClass('active')) {
					$(this).removeClass('current');
					$(target).removeClass('active').slideUp(250);

					// Videos - Empty all players in parent accordion on close
					// $(targetParent + ' .video-wrapper').empty();

				} else {
					$('.accordion-list .accordion-toggle').removeClass('current');
					$('.accordion-list .answer').removeClass('active').slideUp(250);
					$(this).addClass('current');
					$(target).addClass('active').slideDown(250);

					// Videos - Empty all players NOT in target
					// $('.answer:not(' + (target) + ') .video-wrapper').empty();
				}

				// Prevent default 'link' behaviour
				return false;
			});
		}


		// Select2 - Custom Dropdowns
		if ($('.form-wrap .treatment-select').length > 0) {
			$('.treatment-select select').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'Please choose a treatment*',
				// dropdownCssClass: 'filter_dropdown',
			});
		}
		if ($('.form-wrap .interested-in').length > 0) {
			$('.interested-in select').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'I am interested in...',
			});
		}

		/***
		 * Carousels
		 ***/

		// Homepage - Hero header carousel
		if ($('.courses-carousel').length > 0) {
			$('.courses-carousel').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 6000,
				// speed: 5000,
				arrows: false,
				infinite: true,
				centerMode: false,
			});
		}

		// Footer logo carousel
		if ($('.footer-carousel').length > 0) {
			$('.footer-carousel').slick({
				slidesToShow: 6,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 0,
				speed: 5000,
				cssEase: 'linear',
				arrows: false,
				infinite: true,
				centerMode: false,

				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 5,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
						}
					},
				]
			});
		}

		// Room Hire - Brands carousel
		if ($('.brands-carousel').length > 0) {
			$('.brands-carousel').slick({
				slidesToShow: 6,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 0,
				speed: 5000,
				cssEase: 'linear',
				arrows: false,
				infinite: true,
				centerMode: false,

				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 5,
						}
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
						}
					},
				]
			});
		}


		// Careers - Application Form
		if ($('.page-careers .form-wrap.custom-form').length > 0) {
			// Disable submit initially
			$('#gform_submit_button_4').addClass('disabled');
			$('#careers_form_trigger').addClass('disabled');

			// Checkboxes
			$('.page-careers #form-wrapper .form-wrap input[type="checkbox"').click(function () {
				// Disclaimer (mandatory)
				var disclaimerChecked = $("#disclaimer").is(":checked");
				if ((disclaimerChecked == true)) {
					$('#input_5_13').val('Yes');
				} else {
					$('#input_5_13').val('No');
				}

				// Updates
				var updatesChecked = $("#updates").is(":checked");
				if ((updatesChecked == true)) {
					$('#input_5_15').val('Yes');
				} else {
					$('#input_5_15').val('No');
				}

				// Privacy (mandatory)
				var privacyChecked = $("#privacy").is(":checked");
				if ((privacyChecked == true)) {
					$('#input_5_16').val('Yes');
				} else {
					$('#input_5_16').val('No');
				}

				// If both Disclaimer and Updates == Yes, enable submit button
				if ((disclaimerChecked == true) && (privacyChecked == true)) {
					$('#gform_submit_button_5').removeClass('disabled');
					$('#careers_form_trigger').removeClass('disabled');
				}
			});


			// Trigger Gravity Forms button on click
			$('#careers_form_trigger').click(function () {
				if (!$(this).hasClass('disabled')) {
					$('#gform_submit_button_5').trigger('click');
				}
			});

		}


		/*
		// Set Cookie function
		function createCookie(name, value, days) {
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
				var expires = "; expires=" + date.toGMTString();
			} else var expires = "";
			document.cookie = escape(name) + "=" + escape(value) + expires + "; path=/";
		}
		// Privacy Policy Cookies   
		function cookiesPolicyBar(){
			// Check cookie 
			if ($.cookie('cosmedPrivacy') != "accepted") $('#cookie-notification').fadeIn(); 

			//Assign cookie on click
			$('#cookie-notification a, #cookie-notification button').on('click',function(){
				createCookie("cosmedPrivacy", "accepted", 90); // Cookie expires in 90 days
				$('#cookie-notification').fadeOut();
			});
		}           
		// Run cookie policy function
		cookiesPolicyBar();
		*/


	}); // End Document Ready


	// On load
	$(window).on('load', function () {

		// Model form
		if ($('.page-model .form-wrap').length > 0) {
			modelFormLayout();
		}

	});


	// On Scroll
	$(window).on('scroll', function () {

	});


	// On Resize
	$(window).on('resize', function () {

		/*
		// Model form
		if ($('.page-model .form-wrap').length > 0) {
			modelFormLayout(); 
		}
		*/

	});

	function modelFormLayout() {
		var section1_top = $('#model-form').offset().top;

		var section2_top = $('.section-2-start').offset().top,
			section2_bottom = $('.section-2-end').offset().top,
			section2_height = section2_bottom - section2_top;

		var section3_top = $('.section-3-start').offset().top;

		$('.section-2-cover').css('height', section2_height);
		// console.log(section2_height);

		var size = $('body').outerWidth();

		if (size > 1200) {
			$('.radio-row legend.gfield_label').each(function () {
				var labelHeight = $(this).outerHeight();
				$(this).parent().css('min-height', labelHeight);
			});
		} else {
			$('.radio-row').css('height', 'auto');
		}
	}


	// end jQuery wrapper
})(jQuery);